export const GOOGLE_DRIVE_UPLOAD_URL =
  "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id&supportsAllDrives=true";
export const GOOGLE_DRIVE_FOLDER_ID = "10HGvWmY5D7zbM_BHiosFjQ-TWHQfQaox";
export const GOOGLE_DRIVE_FILE_URL = "https://drive.google.com/file/d/";
